var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import loadable from "@loadable/component";
import * as React from "react";
import GameLayout from "src/GameLayout";
import SimpleLayout from "src/SimpleLayout";
import { theme } from "src/styles/theme";
import i18next from "i18next";
var AddCollectionToFolder = loadable(function () {
    return import(
    /* webpackChunkName: 'subscriptions' */ "../pages/AddCollectionToFolder");
});
var AddFriends = loadable(function () {
    return import(
    /* webpackChunkName: 'addFriends' */ "../pages/Onboarding/AddFriends");
});
var Asso = loadable(function () { return import(/* webpackChunkName: 'asso' */ "../pages/Asso"); });
var AuthorCollections = loadable(function () {
    return import(
    /* webpackChunkName: 'authorCollections' */ "../pages/AuthorCollections");
});
var AuthorFolders = loadable(function () {
    return import(/* webpackChunkName: 'authorFolders' */ "../pages/AuthorFolders");
});
var AuthorClassrooms = loadable(function () {
    return import(
    /* webpackChunkName: 'authorClassrooms' */ "../pages/AuthorClassrooms");
});
var Brio = loadable(function () { return import(/* webpackChunkName: 'brio' */ "../pages/Brio"); });
var Collection = loadable(function () { return import(/* webpackChunkName: 'collection' */ "../pages/Collection"); });
var CollectionRecommendations = loadable(function () {
    return import(
    /* webpackChunkName: 'collectionsRecommendations' */ "../pages/CollectionRecommendations");
});
var History = loadable(function () {
    return import(
    /* webpackChunkName: 'history' */ "../pages/History");
});
var CreateCollection = loadable(function () {
    return import(
    /* webpackChunkName: 'createCollection' */ "../pages/CreateCollection");
});
var CreateClassroom = loadable(function () {
    return import(
    /* webpackChunkName: 'createClassroom' */ "../pages/CreateClassroom");
});
var JoinClassroom = loadable(function () {
    return import(/* webpackChunkName: 'createClassroom' */ "../pages/JoinClassroom");
});
var CollectionStats = loadable(function () {
    return import(
    /* webpackChunkName: 'CollectionStats' */ "../pages/CollectionStats");
});
var ClassroomStats = loadable(function () {
    return import(/* webpackChunkName: 'ClassroomStats' */ "../pages/ClassroomStats");
});
var ClassroomStatsCollections = loadable(function () {
    return import(
    /* webpackChunkName: 'ClassroomStatsCollections' */ "../pages/ClassroomStatsCollections");
});
var CreateFolder = loadable(function () { return import(/* webpackChunkName: 'createFolder' */ "../pages/CreateFolder"); });
var Duels = loadable(function () { return import(/* webpackChunkName: 'duels' */ "../pages/Duels"); });
var DuelProvoke = loadable(function () { return import(/* webpackChunkName: 'provoke' */ "../pages/DuelProvoke"); });
var Favorites = loadable(function () { return import(/* webpackChunkName: 'favorites' */ "../pages/Favorites"); });
var Folder = loadable(function () { return import(/* webpackChunkName: 'folder' */ "../pages/Folder"); });
var FolderRecommendations = loadable(function () {
    return import(
    /* webpackChunkName: 'folderRecommendations' */ "../pages/FolderRecommendations");
});
var Memo = loadable(function () { return import(/* webpackChunkName: 'asso' */ "../pages/Memo"); });
var OfficialResources = loadable(function () {
    return import(
    /* webpackChunkName: 'officialResources' */ "../pages/OfficialResources");
});
var MesRevisions = loadable(function () { return import(/* webpackChunkName: 'mesRevisions' */ "../pages/Reviews"); });
var GameResult = loadable(function () { return import(/* webpackChunkName: 'playResults' */ "../pages/GameResult"); });
var Recommendations = loadable(function () {
    return import(
    /* webpackChunkName: 'recommendations' */ "../pages/Recommendations");
});
var Rewards = loadable(function () { return import(/* webpackChunkName: 'rewards' */ "../pages/Rewards"); });
var Settings = loadable(function () { return import(/* webpackChunkName: 'settings' */ "../pages/Settings"); });
var Statistics = loadable(function () { return import(/* webpackChunkName: 'statistics' */ "../pages/Statistics"); });
var Subscriptions = loadable(function () {
    return import(/* webpackChunkName: 'subscriptions' */ "../pages/Subscriptions");
});
var Search = loadable(function () { return import(/* webpackChunkName: 'search' */ "../pages/Search"); });
var Typo = loadable(function () { return import(/* webpackChunkName: 'typo' */ "../pages/Typo"); });
var Quizako = loadable(function () { return import(/* webpackChunkName: 'quizako' */ "../pages/Quizako"); });
var Revisio = loadable(function () { return import(/* webpackChunkName: 'revisio' */ "../pages/Revisio"); });
var Errors = loadable(function () { return import(/* webpackChunkName: 'typo' */ "../pages/Errors"); });
var MergeCollection = loadable(function () {
    return import(
    /* webpackChunkName: 'mergeCollection' */ "../pages/MergeCollection");
});
var SplitCollection = loadable(function () {
    return import(
    /* webpackChunkName: 'splitCollection' */ "../pages/SplitCollection");
});
var CreateDuelClassroom = loadable(function () {
    return import(
    /* webpackChunkName: 'createClassroom' */ "../pages/CreateDuelClassroom");
});
var routes = {
    recommendations: {
        path: "/mes-recommandations",
        component: Recommendations,
        title: i18next.t("title.myRecommendations"),
    },
    authorCollections: {
        path: "/mes-series",
        component: AuthorCollections,
        onlyForTeacher: true,
        title: i18next.t("title.mySeries"),
    },
    authorFolders: {
        path: "/mes-chaines",
        component: AuthorFolders,
        onlyForTeacher: true,
        title: i18next.t("title.myChains"),
    },
    authorClassrooms: {
        path: "/mes-classes",
        component: AuthorClassrooms,
        onlyForTeacher: true,
        title: i18next.t("title.myClassrooms"),
    },
    favorites: {
        path: "/mes-favoris",
        component: Favorites,
        title: i18next.t("title.myFavorites"),
    },
    duels: {
        path: "/mes-duels",
        component: Duels,
        title: i18next.t("title.myDuels"),
    },
    collectionRecommendations: {
        path: "/series/recommandees/:schoolSubject",
        component: CollectionRecommendations,
        title: i18next.t("title.recommendations"),
    },
    history: {
        path: "/historique",
        component: History,
        onlyForStudent: true,
        title: i18next.t("title.history"),
    },
    createCollection: {
        path: "/series/creer",
        component: CreateCollection,
        onlyForTeacher: true,
        title: i18next.t("title.createASerie"),
    },
    editCollection: {
        path: "/series/:id/editer",
        component: function (props) { return (React.createElement(CreateCollection, __assign({}, props, { key: props.match.params.id }))); },
        onlyForTeacher: true,
        title: i18next.t("title.editASerie"),
    },
    createClassroom: {
        path: "/classes/creer",
        component: CreateClassroom,
        onlyForTeacher: true,
        title: i18next.t("title.createAClassroom"),
    },
    editClassroom: {
        path: "/classes/:id/editer",
        component: CreateClassroom,
        onlyForTeacher: true,
        title: i18next.t("title.editAClassroom"),
    },
    addStudentsToClassroom: {
        path: "/classes/:id/ajouter-eleves",
        searchOnlyStudent: true,
        onlyForTeacher: true,
        component: CreateClassroom,
        title: i18next.t("title.addStudentsToClassroom"),
    },
    joinClassroom: {
        path: "/classes/:id/rejoindre",
        onlyForStudent: true,
        component: JoinClassroom,
        title: i18next.t("title.joinAClassroom"),
    },
    classroomStatsCollections: {
        path: "/classes/:classroomId/stats",
        component: ClassroomStatsCollections,
        onlyForTeacher: true,
        title: i18next.t("title.classroomStatsTitle"),
    },
    asso: {
        path: "/series/:id/association/:difficulty?",
        component: Asso,
        layout: GameLayout,
        title: i18next.t("title.game.asso"),
    },
    brio: {
        path: "/series/:id/brio/:difficulty?",
        component: Brio,
        layout: GameLayout,
        title: i18next.t("title.game.brio"),
    },
    memo: {
        path: "/series/:id/memorisation/:difficulty?",
        component: Memo,
        layout: GameLayout,
        title: i18next.t("title.game.memo"),
    },
    officialResources: {
        path: "/ressources-officielles",
        component: OfficialResources,
        title: i18next.t("title.officialResources"),
    },
    mesRevisions: {
        path: "/mes-revisions",
        component: MesRevisions,
        title: i18next.t("title.mesRevisions"),
    },
    typo: {
        path: "/series/:id/typographie/:difficulty?",
        component: Typo,
        layout: GameLayout,
        title: i18next.t("title.game.typo"),
    },
    quizako: {
        path: "/series/:id/quizako/:difficulty?",
        component: Quizako,
        layout: GameLayout,
        title: i18next.t("title.game.quizako"),
    },
    revisio: {
        path: "/series/:id/revisio",
        component: Revisio,
        layout: GameLayout,
        title: i18next.t("title.game.revisio"),
    },
    playResults: {
        path: "/series/:id/resultats",
        component: GameResult,
        title: i18next.t("title.result"),
    },
    provoke: {
        path: "/series/:id/provoke",
        component: DuelProvoke,
        title: i18next.t("title.provokeADuel"),
    },
    classroomStats: {
        path: "/series/:collectionId/classroom/:classroomId/stats",
        component: ClassroomStats,
        title: i18next.t("title.classroomStatsTitle"),
    },
    collectionStats: {
        path: "/series/:id/stats",
        component: CollectionStats,
        onlyForStudent: true,
        title: i18next.t("title.collectionStats"),
    },
    duelClassroom: {
        path: "/series/:id/duel",
        component: CreateDuelClassroom,
        title: i18next.t("title.provokeADuel"),
    },
    mergeCollection: {
        path: "/series/:id/merge",
        component: MergeCollection,
        onlyForTeacher: true,
        title: i18next.t("title.mergeASerie"),
    },
    splitCollection: {
        path: "/series/:id/split",
        component: SplitCollection,
        onlyForTeacher: true,
        title: i18next.t("title.splitASerie"),
    },
    studentStats: {
        path: "/series/:id/student/:studentId/stats",
        component: CollectionStats,
        onlyForTeacher: true,
        title: i18next.t("title.studentStats"),
    },
    collection: {
        path: "/series/:id",
        component: Collection,
        title: i18next.t("title.serieTitle"),
    },
    subscriptions: {
        path: "/chaines/abonnements",
        component: Subscriptions,
        title: i18next.t("title.subscriptions"),
    },
    folderRecommendations: {
        path: "/chaines/recommandees/:schoolSubject",
        component: FolderRecommendations,
        title: i18next.t("title.chainRecommendations"),
    },
    createFolder: {
        path: "/chaines/creer",
        component: CreateFolder,
        onlyForTeacher: true,
        title: i18next.t("title.createAChain"),
    },
    addCollectionToFolder: {
        path: "/chaines/:id/editer-series",
        component: AddCollectionToFolder,
        onlyForTeacher: true,
        title: i18next.t("title.editTheChain"),
    },
    editFolder: {
        path: "/chaines/:id/editer",
        component: CreateFolder,
        onlyForTeacher: true,
        title: i18next.t("title.editTheChain"),
    },
    folder: {
        path: "/chaines/:id",
        component: Folder,
        backgroundColor: theme.colors.gray100,
        title: i18next.t("title.chain"),
    },
    search: {
        path: "/recherche/:search?",
        component: Search,
        title: i18next.t("title.search"),
    },
    addFriendsOnboarding: {
        path: "/bienvenu/amis",
        layout: SimpleLayout,
        showBackToProfileButton: true,
        searchOnlyStudent: true,
        component: AddFriends,
        showOnboarding: false,
        title: i18next.t("title.inviteFriends"),
    },
    settings: {
        path: "/mes-parametres",
        component: Settings,
        title: i18next.t("title.settings"),
    },
    statistics: {
        path: "/mes-statistiques",
        component: Statistics,
        title: i18next.t("title.myStatistics"),
    },
    rewards: {
        path: "/mes-recompenses",
        component: Rewards,
        onlyForStudent: true,
        title: i18next.t("title.myRewards"),
    },
    addFriends: {
        path: "/mes-contacts",
        searchOnlyStudent: true,
        component: AddFriends,
        title: i18next.t("title.inviteFriends"),
    },
    errors: {
        path: "/erreur",
        component: Errors,
        title: i18next.t("title.error"),
    },
};
export default routes;
